export function trimPathEnd(path: string) {
    return path.endsWith('/') ? path.slice(0, path.length - 1) : path;
}

export function trimPathStart(path: string) {
    return path.startsWith('/') ? path.slice(1, path.length) : path;
}
